import { pluck } from 'ramda';
import {
  DISMISS,
  NO,
  PLEASE_RELOAD,
  RELOAD,
  RESYNC_ROUTE,
  RESYNC_ROUTE_NOTIFICATION,
  ROUTE_LEAVE_WARNING,
  SELECT_AFFECTED_STOPS,
  YES,
} from '../../constants/strings';
import { NotificationType } from '../../features/Notifier';
import { getErrorMessage } from '../../utils/errors';

import {
  getNotifications,
  getNotificationsExceptUnlock,
} from '../selectors/notifications';
import { addNotifications, hideNotifications } from '../reducers/notifications';

export const NotificationKeys = {
  RESYNC_ROUTE_KEY: 'resyncSnackbarKey',
  RESYNC_SUCCESSFUL: 'resyncSuccessful',
  LEAVE_ROUTE_NOTIFICATION: 'leaveRoute',
  UNLOCK_ROUTE_NOTIFICATION: 'unlockRoute',
  OUTSTANDING_PARCEL_REQUESTS: 'outstandingParcelRequests',
};

export const showNotification = (notification) => (dispatch, getState) => {
  const currentNotifications = getNotifications(getState());
  const key =
    notification.key || `${currentNotifications.length}${new Date().getTime()}`;
  const hide = () => dispatch(hideNotifications([key]));

  dispatch(
    addNotifications({ key, onClose: hide, onConfirm: hide, ...notification })
  );

  return hide;
};

export const hideNotificationsExceptUnlock = () => (dispatch, getState) => {
  const notifications = getNotificationsExceptUnlock(getState());
  dispatch(hideNotifications(pluck('key', notifications)));
};

export const handleErrorNotification = (error) => (dispatch) => {
  const err = getErrorMessage(error);
  const key = err.replace(/\s/g, '');
  const reloadAction = err === PLEASE_RELOAD;

  const hide = () => dispatch(hideNotifications([key]));
  const refreshPage = () => window.location.reload(true);

  const buttonText = reloadAction ? RELOAD : DISMISS;
  const onConfirm = reloadAction ? refreshPage : hide;
  dispatch(
    showNotification({
      type: NotificationType.ACTION,
      message: err,
      buttonText,
      key,
      onConfirm,
    })
  );
};

export const showResyncRouteNotification =
  ({ onConfirm, error }) =>
  (dispatch) => {
    dispatch(
      showNotification({
        key: NotificationKeys.RESYNC_ROUTE_KEY,
        onCloseText: DISMISS,
        onConfirmText: RESYNC_ROUTE,
        type: NotificationType.ACTIONS,
        message: [getErrorMessage(error), RESYNC_ROUTE_NOTIFICATION],
        onConfirm,
      })
    );
  };

export const showLeaveRouteNotification =
  (onConfirm, onCancel) => (dispatch) => {
    const handleCancel = () => {
      onCancel();
      dispatch(hideNotifications([NotificationKeys.LEAVE_ROUTE_NOTIFICATION]));
    };
    dispatch(
      showNotification({
        key: NotificationKeys.LEAVE_ROUTE_NOTIFICATION,
        onCloseText: NO,
        onConfirmText: YES,
        type: NotificationType.ACTIONS,
        message: ROUTE_LEAVE_WARNING,
        onConfirm,
        onClose: handleCancel,
      })
    );
  };

export const showOutstandingParcelRequestsNotification =
  ({ onConfirm, message }) =>
  (dispatch) => {
    dispatch(
      showNotification({
        key: NotificationKeys.OUTSTANDING_PARCEL_REQUESTS,
        onCloseText: DISMISS,
        onConfirmText: SELECT_AFFECTED_STOPS,
        type: NotificationType.ACTIONS,
        message,
        onConfirm,
      })
    );
  };
